import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../components/Button';

export const StyledOverlay = styled.div<{ isOpen: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  background: ${({ isOpen }) => (isOpen ? 'rgba(9, 37, 64, 0.65)' : 'rgba(9, 37, 64, 0)')};
  transition: background 0.35s ease;
  overflow: hidden;
`;

export const StyledDrawer = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  margin-top: 56px;
  background: ${colorsPalettes.carbon[0]};
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -4px 24px rgba(9, 37, 64, 0.18);
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(100%)')};
  transition: transform 0.4s cubic-bezier(0.32, 0.72, 0, 1);
  overflow: hidden;
`;

export const StyledBody = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const StyledContentArea = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 8px;
`;

export const StyledBodyInitialLoading = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: ${colorsPalettes.carbon[0]};
`;

export const StyledBodyErrorBoundaryWrap = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledFieldLabel = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  margin-bottom: 6px;
`;

export const StyledChartWrapper = styled.div`
  margin: 16px 0;

  > div {
    max-width: 100%;
  }
`;

export const StyledResultContainer = styled.div<{ $grow?: boolean }>`
  flex: ${({ $grow }) => ($grow ? '1' : '0 0 auto')};
  min-height: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledPickerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledPickerBackArrow = styled(Button)`
  width: 24px;
  height: 24px;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4px;
  color: ${colorsPalettes.carbon[500]};

  &:hover,
  &:active {
    background: transparent;
    opacity: 0.7;
  }
`;

export const StyledPickerHeaderTitle = styled.div`
  ${setFontVariant('primaryItem', colorsPalettes.carbon[500])};
`;
